import React from "react";
import useResponsive from "../../hooks/useResponsive";
import MuiModal from "@mui/material/Modal";
import { Close } from "../../assets/svg/icons";

const ModalContainer = ({ open, handleClose }) => {
  const { Mobile, Default } = useResponsive();

  return (
    <MuiModal
      className="modal"
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-help"
      aria-describedby="modal-help-description"
    >
      <div className="modal-content_container">
        <Default>
          <div className="modal_header">
            <h2 id="modal-help">Hur spelar man Vem bestämmer?</h2>
            <button
              className="modal-close_button sm_btn"
              onClick={handleClose}
              aria-label="Stäng instruktioner"
            >
              <span className="btn_text">Stäng</span>
              <Close className="close_icon" />
            </button>
          </div>
        </Default>
        <Mobile>
          <div className="mobile-modal_header">
            <button
              className="modal-close_button sm_btn"
              onClick={handleClose}
              aria-label="Stäng instruktioner"
            >
              <Close className="close_icon" />
            </button>
            <h2 id="modal-help">Hur spelar man Vem bestämmer?</h2>
          </div>
        </Mobile>
        <div className="modal-content">
          <ol id="modal-help-description" className="help-instructions_list">
            <Default>
              <li>Klicka på en figur i bilden.</li>
              <li>
                Välj ett utav de tre svarsalternativen du tror är rätt svar på
                frågan.
              </li>
              <li>Klicka på knappen Svara.</li>
              <li>
                Välj sedan om du vill välja en ny figur från bilden. Eller
                klicka på navigeringen längst ned för att få en ny fråga.
              </li>
            </Default>
            <Mobile>
              <li>
                Välj ett utav de tre svarsalternativen du tror är rätt svar på
                frågan.
              </li>
              <li>
                Använd knapparna längst ned för att navigera mellan alla frågor
              </li>
              <li>
                När den sista frågan är besvarad kan du se ditt resultat på
                resultatsidan.
              </li>
            </Mobile>
          </ol>
          {/* <button
            className="modal-close_button lg_btn"
            onClick={() => handleClose(false)}
            aria-label="Stäng instruktioner"
          >
            <span>Stäng</span>
            <Close className="close_icon" />
          </button> */}
        </div>
      </div>
    </MuiModal>
  );
};

export default ModalContainer;
